import { render, staticRenderFns } from "./AscentCragRouteSmallCard.vue?vue&type=template&id=b282a808"
import script from "./AscentCragRouteSmallCard.vue?vue&type=script&lang=js"
export * from "./AscentCragRouteSmallCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports